(function () {
    'use strict';
    var m = angular.module('gui-v2');
    m.directive('dashboardEventsHeatMap', ["path", "$q", "ipDao", "modulesManager", "$timeout", "feature", function (path, $q, ipDao, modulesManager, $timeout, feature) {
        return {
            restrict: 'A',
            replace: false,
            templateUrl: path('gui-v2').directive('dashboard/events-heat-map').template('events-heat-map'),
            scope: { resolution: '=' },
            link: function ($scope, element, attrs) {
                $scope.widgetApi = {};
                var maxLimitCount = 5000;
                //don't set this value highter than 5000
                function init() {
                    $scope.saasAll = [{
                            autoId: 'dashboard_event_heat_map_saas_dropdown_item_all_failed',
                            title: 'All failed login events',
                            id: 'all_failed'
                        }];
                    if (!feature.enableDashboardMapFailedOnly) {
                        $scope.saasAll.unshift({
                            autoId: 'dashboard_event_heat_map_saas_dropdown_item_all_success',
                            title: 'All successful login events',
                            id: 'all'
                        });
                    }
                    $scope.selectedSaas = $scope.saasAll[0];
                    $scope.selectedSaasIds = [$scope.saasAll[0].id];
                    $scope.selectedSaass = $scope.saasAll[0].title;
                    $scope.model = $scope.model || {
                        data: [],
                        saasData: {},
                        saasDataAll: {},
                        options: {
                            autoId: 'dashboard_event_heat_map_saas_dropdown',
                            multiple: true,
                            emptyLabel: feature.enableDashboardMapFailedOnly ? 'Failed Login Events' : 'Login Events',
                            showAll: false,
                            selectedLabelType: 'empty',
                            keepOpenOnLocation: true,
                            specialType: 'heat_map'
                        }
                    };
                    $scope.saasInfo = {};
                    $scope.loading = true;
                    $scope.saasList = _.clone($scope.saasAll);
                    $scope.pointQueryFilters = {
                        filterByTime: undefined,
                        filterByOfficeLoginEventType: undefined
                    };
                }
                init();
                var initMap = false;
                var missingSaaS = {};
                var mapSingleton = null;
                var itemsToCollapseDetails = 200;
                var bounds = [];
                var prevIds = [$scope.saasAll[0].id];
                var resolution = 'week';
                // work for only week
                // $scope.$watch('resolution', function(newVal, oldVal) {
                //     if(newVal !== oldVal) {
                //         bounds = [];
                //         init();
                //         $scope.widgetApi.reload();
                //     }
                // });
                var loadTimeout = $q.defer();
                // default is to get the value from fast cache table.
                // since there is a bug with UI feature, setting this value to true;
                var useCacheQuery = true;
                //feature.heatMapFastCache;
                $scope.loadData = function () {
                    if (!initMap) {
                        updateData();
                        initMap = true;
                    }
                    $scope.saasInfo = {};
                    var loadedData = {};
                    loadTimeout.resolve();
                    loadTimeout = $q.defer();
                    //First draw the map and set the relevant data after.
                    return modulesManager.init().then(function () {
                        var clonedApps = _.clone(modulesManager.activeSaasApps());
                        var activeApps = [];
                        _(clonedApps).each(function (app) {
                            app.failed = 0;
                            app.id = app.name;
                            var appFailed = _.clone(app);
                            appFailed.failed = 1;
                            appFailed.id = appFailed.name + '_failed';
                            if (!feature.enableDashboardMapFailedOnly) {
                                activeApps.push(app);
                            }
                            activeApps.push(appFailed);
                        });
                        return $q.allSettled(_(activeApps).map(function (saas, key) {
                            if (missingSaaS[saas.id]) {
                                return;
                            }
                            $scope.saasInfo[saas.id] = {
                                autoId: 'dashboard_event_heat_map_saas_dropdown_item_' + saas.id,
                                title: transformSaasTitle(saas.name, saas.title, saas.failed),
                                id: saas.id
                            };
                            // returns function to call fast cache table or normal table.
                            if (feature.enableHeatMapDayResolutionOnly) {
                                resolution = 'day';
                            }
                            return $scope.getHeatMapDataMethod(saas.name, saas.failed, resolution).timeout(loadTimeout.promise).onRequestFail(function (error) {
                                if (error.status === 404) {
                                    missingSaaS[saas.id] = true;
                                }
                                return $q.when();
                            });
                        })).then(function (responses) {
                            // decode and decompress the each responses
                            _(activeApps).map(function (saas, key) {
                                if (responses[key] && responses[key].value && responses[key].value.data && responses[key].value.data.rows) {
                                    if (useCacheQuery && responses[key].value.data.rows.length > 0) {
                                        var strData = atob(responses[key].value.data.rows);
                                        var charData = strData.split('').map(function (x) {
                                            return x.charCodeAt(0);
                                        });
                                        var binData = new Uint8Array(charData);
                                        var decompressed = pako.inflate(binData);
                                        strData = arrayBufferToString(decompressed);
                                        // double parse is made since backend doing double stringify
                                        // for maintaining unicode str on non ascii chars
                                        // first parse -> convert unicode to chars
                                        strData = JSON.parse(strData);
                                        if (typeof strData === 'string') {
                                            // second parse -> convert json-str to object
                                            responses[key].value.data.rows = JSON.parse(strData);
                                        }    // fallback if already parsed
                                        else {
                                            responses[key].value.data.rows = strData;
                                        }
                                    }
                                    if (!loadedData[saas.id]) {
                                        loadedData[saas.id] = [];
                                    }
                                    loadedData[saas.id] = loadedData[saas.id].concat(responses[key].value.data.rows);
                                    activeApps[key].currentPage = 0;
                                    activeApps[key].total = responses[key].value.data.total_rows || 0;
                                    activeApps[key].pages = Math.floor(activeApps[key].total / maxLimitCount);
                                }
                            });
                            $scope.saasList = [];
                            var list = _(activeApps).chain().filter(function (app) {
                                return loadedData[app.id] && loadedData[app.id].length;
                            }).pluck('id').value();
                            _(list).each(function (saasId) {
                                $scope.saasList.push($scope.saasInfo[saasId]);
                            });
                            if (feature.enableDashboardMapFailedOnly) {
                                $scope.saasList.unshift($scope.saasAll[0]);
                            } else {
                                $scope.saasList.unshift($scope.saasAll[0], $scope.saasAll[1]);
                            }
                            $scope.model.saasDataAll = loadedData;
                            var zoomIn = true;
                            var rowsCount = 0;
                            for (var key in loadedData) {
                                rowsCount += loadedData[key].length;
                                if (loadedData[key].length > 3000) {
                                    zoomIn = false;
                                }
                            }
                            if (zoomIn) {
                                filterDataForSelector($scope.selectedSaasIds);
                            }
                            if ($scope.loading) {
                                var latLngBounds = L.latLngBounds(bounds);
                                if (latLngBounds.isValid()) {
                                    mapSingleton.fitBounds(latLngBounds);
                                }
                            }
                            var query = [];
                            _(activeApps).map(function (saas, key) {
                                if (!missingSaaS[saas.id] && activeApps[key].total && activeApps[key].total > maxLimitCount) {
                                    for (var i = 0; i < saas.pages; i++) {
                                        query.push(ipDao.heatMapRes(saas.name, resolution, saas.failed, {
                                            offset: (i + 1) * maxLimitCount,
                                            limit: maxLimitCount,
                                            showTotal: false
                                        }));
                                    }
                                }
                            });
                            $q.allSettled(query).then(function (responses) {
                                var count = 0;
                                // if we dont get date from fast cache table, try to use API to get data from cache table.
                                if (loadedData.length === 0 && useCacheQuery) {
                                    useCacheQuery = false;
                                    $scope.loadData();
                                    return;
                                }
                                $scope.loading = false;
                                _(activeApps).map(function (saas, key) {
                                    if (!missingSaaS[saas.id] && activeApps[key].total && activeApps[key].total > maxLimitCount) {
                                        for (var i = 0; i < saas.pages; i++) {
                                            if (responses[count] && responses[count].value && responses[count].value.data && responses[count].value.data.rows) {
                                                if (!loadedData[saas.id]) {
                                                    loadedData[saas.id] = [];
                                                }
                                                loadedData[saas.id] = loadedData[saas.id].concat(responses[count].value.data.rows);
                                                activeApps[key].currentPage = saas.currentPage + 1;
                                            }
                                            count++;
                                        }
                                    }
                                });
                                filterDataForSelector($scope.selectedSaasIds);
                                var latLngBounds = L.latLngBounds(bounds);
                                if (latLngBounds.isValid()) {
                                    mapSingleton.fitBounds(latLngBounds);
                                }
                            });
                        });
                    });
                };
                $scope.getHeatMapDataMethod = function (name, failed, resolution) {
                    if (useCacheQuery) {
                        return ipDao.heatMapResCache(name, failed, resolution);
                    } else {
                        return ipDao.heatMapRes(name, resolution, failed, {
                            offset: 0,
                            limit: maxLimitCount,
                            showTotal: true
                        });
                    }
                };
                $scope.selectSaas = function (selectedSaasIds) {
                    var different1 = _.difference(selectedSaasIds, prevIds);
                    var different2 = _.difference(prevIds, selectedSaasIds);
                    if (different1.length > 0) {
                        if (different1.indexOf('all') !== -1) {
                            prevIds = [];
                            _($scope.saasList).each(function (saas) {
                                if (saas.id.indexOf('_failed') === -1) {
                                    prevIds.push(saas.id);
                                }
                            });
                        } else if (different1.indexOf('all_failed') !== -1) {
                            prevIds = [];
                            _($scope.saasList).each(function (saas) {
                                if (saas.id.indexOf('_failed') !== -1) {
                                    prevIds.push(saas.id);
                                }
                            });
                        } else {
                            if (prevIds.indexOf('all') !== -1 || prevIds.indexOf('all_failed') !== -1) {
                                prevIds = _.clone(different1);
                            } else {
                                prevIds = _.clone($scope.selectedSaasIds);
                            }
                        }
                    } else if (different2.length > 0) {
                        if (different2.indexOf('all') !== -1 || different2.indexOf('all_failed') !== -1) {
                            prevIds = [];
                            $scope.selectedSaasIds = [];
                        } else {
                            prevIds = _.clone($scope.selectedSaasIds);
                            if (prevIds.indexOf('all') !== -1) {
                                prevIds.splice(prevIds.indexOf('all'), 1);
                            } else if (prevIds.indexOf('all_failed') !== -1) {
                                prevIds.splice(prevIds.indexOf('all_failed'), 1);
                            }
                        }
                    } else {
                        prevIds = [];
                        _($scope.saasList).each(function (saas) {
                            if (saas.id.indexOf('_failed') === -1) {
                                prevIds.push(saas.id);
                                $scope.model.saasData[saas.id] = $scope.model.saasDataAll[saas.id] || [];
                            }
                        });
                    }
                    filterDataForSelector(prevIds);
                };
                function transformSaasTitle(saasName, title, failed) {
                    var add = ' successful login events';
                    var t = '';
                    if (failed == 1) {
                        add = ' failed login events';
                    }
                    if (saasName === 'google_drive') {
                        t = 'G-Suite' + add;
                    } else if (saasName === 'office365_emails') {
                        t = 'Office 365' + add;
                    } else {
                        t = title + add;
                    }
                    return t;
                }
                function filterDataForSelector(selectedSaasIds) {
                    $scope.model.saasData = {};
                    $scope.selectedSaasIds = _.clone(selectedSaasIds);
                    if ((!selectedSaasIds || _.isEqual(selectedSaasIds, ['all'])) && !feature.enableDashboardMapFailedOnly) {
                        $scope.selectedSaasIds = [];
                        _($scope.saasList).each(function (saas) {
                            if (saas.id.indexOf('_failed') === -1) {
                                $scope.selectedSaasIds.push(saas.id);
                                $scope.model.saasData[saas.id] = $scope.model.saasDataAll[saas.id] || [];
                            }
                        });
                    } else if (feature.enableDashboardMapFailedOnly && _.isEqual(selectedSaasIds, ['all_failed'])) {
                        $scope.selectedSaasIds = [];
                        _($scope.saasList).each(function (saas) {
                            if (saas.id.indexOf('_failed') !== -1) {
                                $scope.selectedSaasIds.push(saas.id);
                                $scope.model.saasData[saas.id] = $scope.model.saasDataAll[saas.id] || [];
                            }
                        });
                    } else {
                        _(selectedSaasIds).each(function (saasId) {
                            $scope.model.saasData[saasId] = $scope.model.saasDataAll[saasId] || [];
                        });
                    }
                    prevIds = _.clone($scope.selectedSaasIds);
                    updateData();
                }
                function arrayBufferToString(buffer) {
                    var bufView = new Uint16Array(buffer);
                    var length = bufView.length;
                    var result = '';
                    var addition = Math.pow(2, 16) - 1;
                    for (var i = 0; i < length; i += addition) {
                        if (i + addition > length) {
                            addition = length - i;
                        }
                        result += String.fromCharCode.apply(null, bufView.subarray(i, i + addition));
                    }
                    return result;
                }
                function getMap() {
                    if (_(mapSingleton).isNull()) {
                        var tiles = L.tileLayer('https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}.png', {
                            id: 'tiles-layer',
                            maxZoom: 19,
                            minZoom: 1,
                            subdomains: 'abcd',
                            attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> &copy; <a href="https://cartodb.com/attributions">CartoDB</a>'
                        });
                        mapSingleton = L.map(element.find('.map-container')[0], {
                            layers: [tiles],
                            worldCopyJump: true
                        });
                        mapSingleton.fitWorld();
                    }
                    return mapSingleton;
                }
                function getHtmlIcon() {
                    return L.Icon.extend({
                        options: {},
                        initialize: function (options) {
                            L.Util.setOptions(this, options);
                        },
                        createIcon: function () {
                            var div = document.createElement('div');
                            div.innerHTML = this.options.html;
                            return div;
                        },
                        createShadow: function () {
                            return null;
                        }
                    });
                }
                function getCountClass(count, single) {
                    var countClass = '';
                    if (single !== undefined) {
                        countClass = single ? 'single-cluster ' : 'multiple-cluster ';
                    }
                    if (count <= 10) {
                        countClass += 'newcluster1';
                    } else if (count <= 50) {
                        countClass += 'newcluster10';
                    } else {
                        countClass += 'newcluster50';
                    }
                    return countClass;
                }
                function getQueryUrlForPoint(point) {
                    var ips = point.usersMetadata.map(function (event) {
                        return event.ip;
                    });
                    var conditions = _(ips).uniq().map(function (ip) {
                        return {
                            data: ip,
                            not: false,
                            operator: 'is',
                            options: {},
                            property: 'office365_mgmnt_login_event.ClientIP',
                            type: 'condition'
                        };
                    });
                    var filterByIP = {
                        conditions: conditions,
                        not: false,
                        operator: 'OR',
                        type: 'group'
                    };
                    var filter = [
                        $scope.pointQueryFilters.filterByTime,
                        filterByIP
                    ];
                    if ($scope.pointQueryFilters.filterByOfficeLoginEventType) {
                        filter.push($scope.pointQueryFilters.filterByOfficeLoginEventType);
                    }
                    var filterParam = btoa(JSON.stringify(filter));
                    var url = '#!/query/create/office365_emails?entity=office365_mgmnt_login_event&hideFilters=true&showPolicyTable=false&filter={0}';
                    url = url.replace('{0}', filterParam);
                    return url;
                }
                function createQueryLink(point) {
                    var url = getQueryUrlForPoint(point);
                    var html = '<a href="{0}" style="float:right">{1}</a>'.replace('{0}', url).replace('{1}', 'Show Details');
                    return html;
                }
                function composeTooltipText(point) {
                    var popupText = '';
                    if (point.uniqueItems < 13000) {
                        var users = _(point.usersMetadata).chain().pluck('email').uniq().value().length;
                        if (point.uniqueItems > itemsToCollapseDetails) {
                            return '<b>' + users + ' ' + ' user' + (users > 1 ? 's' : '') + ' (' + point.uniqueItems + ' unique geo events) </b>';
                        }
                        var ips = _(point.usersMetadata).chain().pluck('ip').uniq().value().length;
                        popupText = '<b>' + users + ' user' + (users > 1 ? 's' : '') + ' from ' + ips + ' IP' + (ips > 1 ? 's' : '') + ':</b>';
                        _(point.usersMetadata).each(function (metadata) {
                            popupText += '<br/>' + metadata.name + ' (' + metadata.ip + ')';
                        });
                        var isOfficeMailEvents = point.saas.find(function (app) {
                            return app.id.startsWith('office365_emails');
                        });
                        if (!!isOfficeMailEvents) {
                            popupText = createQueryLink(point) + '<br>' + popupText;
                        }
                    }
                    return popupText;
                }
                function formatNumber(number, decPlaces) {
                    decPlaces = Math.pow(10, decPlaces);
                    var abbrev = [
                        'k',
                        'm',
                        'b',
                        't'
                    ];
                    // Go through the array backwards, so we do the largest first
                    for (var i = abbrev.length - 1; i >= 0; i--) {
                        // Convert array index to "1000", "1000000", etc
                        var size = Math.pow(10, (i + 1) * 3);
                        // If the number is bigger or equal do the abbreviation
                        if (size <= number) {
                            // Here, we multiply by decPlaces, round, and then divide by decPlaces.
                            // This gives us nice rounding to a particular decimal place.
                            number = Math.round(number * decPlaces / size) / decPlaces;
                            // Handle special case where we round up to the next abbreviation
                            if (number === 1000 && i < abbrev.length - 1) {
                                number = 1;
                                i++;
                            }
                            // Add the letter for the abbreviation
                            number += abbrev[i];
                            break;
                        }
                    }
                    return number;
                }
                function getUsersList(point) {
                    if (point.metainfo) {
                        return _(point.metainfo).map(function (data) {
                            return {
                                email: data.email,
                                name: data.name && data.name.trim() || data.email || 'Unknown user',
                                ip: data.ip
                            };
                        });
                    }
                    var list = [];
                    if (point.metadata) {
                        var dataList = point.metadata.split(',');
                        for (var i = 0; i < dataList.length; i += 3) {
                            list.push({
                                email: dataList[i],
                                name: dataList[i + 1],
                                ip: dataList[i + 2]
                            });
                        }
                    }
                    return list;
                }
                function updateData() {
                    var map = getMap();
                    map.eachLayer(function (layer) {
                        if (layer.options.id !== 'tiles-layer') {
                            map.removeLayer(layer);
                        }
                    });
                    var allData = {};
                    var markers = L.markerClusterGroup({
                        showCoverageOnHover: false,
                        iconCreateFunction: function (cluster) {
                            var countMarkers = 0;
                            var clusterChilds = cluster.getAllChildMarkers();
                            _(clusterChilds).each(function (child) {
                                countMarkers += child.uniqueItems;
                            });
                            var countClass = getCountClass(countMarkers);
                            return L.divIcon({ html: '<div class="newcluster ' + countClass + '" data-events="' + countMarkers + '"><div>' + countMarkers + '</div></div>' });
                        }
                    });
                    _($scope.model.saasData).each(function (data, saasKey) {
                        _(data).each(function (point) {
                            var key = point.geo_lat + '_' + point.geo_lon;
                            var userList = getUsersList(point);
                            // var uniqueItems = _(point.uniqueItems).isUndefined() ? userList.length : (point.uniqueItems || 0);
                            // var uniqueEmails = point.uniqueEmails || 0;
                            // var uniqueIps = point.uniqueIps || 0;
                            var items = point.hasOwnProperty('uniqueItems') ? point.uniqueItems : point.uniqueitems;
                            var emails = point.hasOwnProperty('uniqueEmails') ? point.uniqueEmails : point.uniqueemails;
                            var ips = point.hasOwnProperty('uniqueIps') ? point.uniqueIps : point.uniqueips;
                            var uniqueItems = _(items).isUndefined() || items === null ? userList.length : items || 0;
                            var uniqueEmails = emails || 0;
                            var uniqueIps = ips || 0;
                            if (!allData[key]) {
                                allData[key] = {
                                    geo_lat: point.geo_lat,
                                    geo_lon: point.geo_lon,
                                    count: point.count,
                                    usersMetadata: userList,
                                    saas: [$scope.saasInfo[saasKey]],
                                    uniqueItems: uniqueItems,
                                    uniqueEmails: uniqueEmails,
                                    uniqueIps: uniqueIps
                                };
                            } else {
                                allData[key].count += point.count;
                                allData[key].saas = _(allData[key].saas).union([$scope.saasInfo[saasKey]]);
                                allData[key].usersMetadata = _(allData[key].usersMetadata).union(userList);
                                allData[key].uniqueItems += uniqueItems;
                                allData[key].uniqueEmails += uniqueEmails;
                                allData[key].uniqueIps += uniqueIps;
                            }
                        });
                    });
                    $scope.model.data = _(allData).values();
                    L.HtmlIcon = getHtmlIcon();
                    var closePopupTimeout;
                    function closePopup(parent, popup, time) {
                        closePopupTimeout = $timeout(function () {
                            parent.closePopup();
                            $(popup._container).off('mouseenter');
                            $(popup._container).off('mouseleave');
                        }, time);
                    }
                    updatePointQueryFilters();
                    _($scope.model.data).each(function (point) {
                        if ($scope.loading) {
                            bounds.push([
                                point.geo_lat,
                                point.geo_lon
                            ]);
                        }
                        var markerLocation = new L.LatLng(point.geo_lat, point.geo_lon);
                        var singleMarker = point.uniqueItems === 1;
                        var countClass = getCountClass(point.count, singleMarker);
                        var CustomHtmlIcon = L.HtmlIcon.extend({ options: { html: '<div class=\'marker-saas ' + countClass + '\'>' + (singleMarker ? '' : formatNumber(point.uniqueItems, 0)) + '</div>' } });
                        var customHtmlIcon = new CustomHtmlIcon();
                        var markerTooltipText = composeTooltipText(point);
                        var marker = L.marker(markerLocation, { icon: customHtmlIcon });
                        marker.uniqueItems = point.uniqueItems;
                        var popup = L.popup({
                            closeButton: false,
                            className: point.uniqueItems > 1 ? 'multiple' : 'single'
                        }).setContent(markerTooltipText);
                        marker.bindPopup(popup);
                        marker.on('mouseover', function (e) {
                            marker.openPopup();
                            $timeout.cancel(closePopupTimeout);
                        });
                        marker.on('mouseout', function () {
                            var popup = marker.getPopup();
                            closePopup(marker, popup, 2000);
                            $(popup._container).on('mouseenter', function () {
                                $timeout.cancel(closePopupTimeout);
                            });
                            $(popup._container).on('mouseleave', function () {
                                closePopup(marker, popup, 2000);
                            });
                        });
                        markers.addLayer(marker);
                    });
                    var clusterPopup;
                    markers.on('clustermouseover', function (e) {
                        var popupText = e.layer.getElement(e.target).querySelector('[data-events]').dataset.events + ' unique geo events';
                        clusterPopup = L.popup({
                            closeButton: false,
                            className: 'cluster'
                        }).setContent(popupText);
                        e.layer.bindPopup(clusterPopup).openPopup();
                    });
                    markers.on('clustermouseout', function (e) {
                        closePopup(e.layer, clusterPopup, 2000);
                        $(clusterPopup._container).on('mouseenter', function () {
                            $timeout.cancel(closePopupTimeout);
                        });
                        $(clusterPopup._container).on('mouseleave', function () {
                            closePopup(e.layer, clusterPopup, 2000);
                        });
                    });
                    map.addLayer(markers);
                }
                function updatePointQueryFilters() {
                    var last7Days = new Date();
                    last7Days.setHours(0, 0, 0, 0);
                    last7Days.setDate(last7Days.getDate() - 7);
                    var eventTypeMap = {
                        'office365_emails': 'UserLoggedIn',
                        'office365_emails_failed': 'UserLoginFailed'
                    };
                    var selectedLoginEventTypes = $scope.selectedSaasIds.filter(function (type) {
                        return type.startsWith('office365_emails');
                    });
                    $scope.pointQueryFilters.filterByTime = {
                        data: last7Days.getTime(),
                        not: false,
                        operator: 'date_after',
                        options: {},
                        property: 'office365_mgmnt_login_event.CreationTime',
                        type: 'condition'
                    };
                    $scope.pointQueryFilters.filterByOfficeLoginEventType = undefined;
                    if (selectedLoginEventTypes.length === 1) {
                        var filterEventType = eventTypeMap[selectedLoginEventTypes[0]];
                        $scope.pointQueryFilters.filterByOfficeLoginEventType = {
                            data: filterEventType,
                            not: false,
                            operator: 'is',
                            options: { ignoreCase: true },
                            property: 'office365_mgmnt_login_event.Operation',
                            type: 'condition'
                        };
                    }
                }
                $scope.$on('$destroy', function () {
                    if (!_(mapSingleton).isNull()) {
                        mapSingleton.remove();
                    }
                });
            }
        };
    }]);
}());